import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
} from "reactstrap";
import classnames from "classnames";

import { connect } from "react-redux";
import FiltertRightbar from "../FiltersRightbar";
import AllPurchase from "./AllPurchase";
import "../PurchaseIndent.scss";

import {
  getPIReqList,
  SetParams,
  getPIListcount,
  FiltersShowRightSidebar,
  FilterClear,
} from "../../../store/PurchaseIndent/actions";
import LoadingModel from "../../LoadingModel";

class HodPurchaseIndent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      currentPage: 1,
      FilterToggle: false,
    };
    this.toggleTab = this.toggleTab.bind(this);
  }

  toggleTab(tab) {
    var pistatus = [0];
    if (tab === 1) {
      pistatus = [0];
    } else if (tab !== 2) {
      pistatus = [tab];
    } else if (tab === 2) {
      pistatus = [1, 2];
    }
    this.props.SetParams({
      ...this.props.params,
      pistatus: pistatus,
      page: 1,
      // start_date: "",
      // end_date: "",
    });
    this.props.getPIReqList({
      ...this.props.params,
      pistatus: pistatus,
      page: 1,
      // start_date: "",
      // end_date: "",
    });
  }
  componentDidMount() {
    this.props.FilterClear();

    this.props.getPIListcount();
    this.props.SetParams({
      ...this.props.params,
      pistatus: [0],
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      department: "",
      piitems__product: "",
    });
    this.props.getPIReqList({
      ...this.props.params,
      pistatus: [0],
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      department: "",
      piitems__product: "",
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content ">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}
            <Row>
              <Col lg={12}>
                <Card className="pagebody">
                  <CardHeader className="bg-transparent pb-0">
                    <h5 className="card-title-18 pt-2 d-inline-block">
                      Purchase Indent Dashboard
                    </h5>
                    <div className="float-right">
                      <div className="d-inline-block">
                        <Button
                          type="button"
                          color="light"
                          className="waves-effect waves-light d-flex  mr-2"
                          onClick={() => this.props.FiltersShowRightSidebar(2)}
                        >
                          <i className="mdi mdi-filter"></i>
                          <span className="d-none d-lg-block ml-1">
                            Filters
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-0">
                    <Nav tabs className="nav-tabs-custom ">
                      <NavItem>
                        <NavLink
                          onClick={() => {
                            this.toggleTab(1);
                          }}
                          className={classnames(
                            { active: this.props.params.pistatus[0] === 0 },
                            "pt-3 font-weight-bold card-title-16"
                          )}
                        >
                          All | <span>{this.props.PIListCount?.all_count}</span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          onClick={() => {
                            this.toggleTab(2);
                          }}
                          className={classnames(
                            { active: this.props.params.pistatus[0] === 1 },
                            "pt-3 font-weight-bold card-title-16"
                          )}
                        >
                          Pending |{" "}
                          <span>{this.props.PIListCount?.pending_count}</span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          onClick={() => {
                            this.toggleTab(3);
                          }}
                          className={classnames(
                            { active: this.props.params.pistatus[0] === 3 },
                            "pt-3 font-weight-bold card-title-16"
                          )}
                        >
                          Approved |{" "}
                          <span>{this.props.PIListCount?.approved_count}</span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          onClick={() => {
                            this.toggleTab(4);
                          }}
                          className={classnames(
                            { active: this.props.params.pistatus[0] === 4 },
                            "pt-3 font-weight-bold card-title-16"
                          )}
                        >
                          Rejected |{" "}
                          <span>{this.props.PIListCount?.rejected_count}</span>
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent>
                      <AllPurchase />
                    </TabContent>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <FiltertRightbar />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const {
    PIRowList,
    params,
    PIListCount,
    PIRowListCount,
    PIListModel,
    loading,
  } = state.PurchaseIndent;
  return {
    PIRowList,
    PIRowListCount,
    PIListCount,
    params,
    PIListModel,
    loading,
    //---------
  };
};

export default connect(mapStatetoProps, {
  getPIReqList,
  SetParams,
  getPIListcount,
  FiltersShowRightSidebar,
  FilterClear,
})(HodPurchaseIndent);
